import { Mail } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { TermsSection } from '../../constants/termsContent';

interface TermsSectionProps {
  section: TermsSection;
  index: number;
}

export function TermsSectionComponent({ section, index }: TermsSectionProps) {
  const { t } = useLanguage();
  const isFrench = t('nav.language') === 'EN';

  return (
    <section key={index}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4 border-l-4 border-[#f91bdc] pl-4">
        {isFrench ? section.titleFr || section.title : section.title}
      </h3>
      
      <p className="text-gray-700 leading-relaxed mb-4">
        {isFrench ? section.contentFr || section.content : section.content}
      </p>
      
      {section.details && (
        <div className="bg-gray-50 rounded-lg p-4 space-y-2">
          {section.details.map((detail, detailIndex) => (
            <div key={detailIndex} className="flex items-start space-x-3">
              <div className="w-1.5 h-1.5 bg-[#f91bdc] rounded-full mt-2 flex-shrink-0"></div>
              <span className="text-gray-700 text-sm">
                {isFrench ? detail.fr : detail.en}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Special contact section */}
      {section.title.includes("Contact Information") && (
        <div className="bg-[#f91bdc]/10 rounded-lg p-6 mt-4">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <h4 className="font-semibold text-gray-900 mb-2">{t('terms.emailSupport')}</h4>
              <div className="flex items-center space-x-2 text-[#f91bdc]">
                <Mail size={16} />
                <a 
                  href="mailto:Contact@sayaara.com" 
                  className="font-medium hover:text-[#e015c9] transition-colors duration-200"
                >
                  Contact@sayaara.com
                </a>
              </div>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-2">{t('terms.phoneSupport')}</h4>
              <div className="flex items-center space-x-2 text-[#f91bdc]">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a 
                  href="tel:+14378871015" 
                  className="font-medium hover:text-[#e015c9] transition-colors duration-200"
                >
                  +1 (437) 887-1015
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}